import { Injectable } from '@angular/core';
import type { Reference } from '@freelancer/datastore/core';
import { stringifyReference, uniqWith } from '@freelancer/datastore/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

export interface DatastoreFetchRecord {
  readonly ref: Reference<any>;
  readonly query: string;
  readonly loaded: boolean;
}

@UntilDestroy({ className: 'DatastoreRecorder' })
@Injectable({
  providedIn: 'root',
})
export class DatastoreRecorder {
  private _collectionRecord$ = new BehaviorSubject<{
    [key in string]: readonly DatastoreFetchRecord[];
  }>({});
  collectionRecord$ = this._collectionRecord$.asObservable();

  addRecord(ref: Reference<any>, loaded: boolean): void {
    const currentCollectionRecord = this._collectionRecord$.getValue();
    const newCollectionRecord = {
      ...currentCollectionRecord,
      [ref.path.collection]: uniqWith(
        [
          // parse the reference into a stringified query
          {
            ref,
            query: stringifyReference(ref),
            loaded,
          },
          // add existing collection if it exists
          // note: this goes last so we push out old records when running `uniqWith`
          ...(currentCollectionRecord[ref.path.collection] ?? []),
        ],
        // and merge entries with the same query
        (a, b) => a.query === b.query,
      ),
    };
    this._collectionRecord$.next(newCollectionRecord);
  }

  reset(): void {
    this._collectionRecord$.next({});
  }
}
